import { useFontScale } from '../hooks/useFontScale';

/**
 * FontScaleApplier — reads the saved font-scale from localStorage and applies
 * it to `<html style="font-size">` for the whole app on mount. Mounted once
 * at the root of App.js so the scale sticks across every route.
 */
const FontScaleApplier = () => {
  useFontScale();
  return null;
};

export default FontScaleApplier;
